import type { Trait } from '../../../../../Flux/Slice/Visualization/VisualizationSliceTypes.ts'

/** Normalise a taxon/trait name for case-insensitive matching (trim + lowercase). */
export const normTaxon = (x: string): string => (x ?? '').trim().toLowerCase()

/**
 * Builds `normalised(consensustaxon) → [traitName]` for one trait group. Shared by the trait
 * transformers (`traitStackedBarSeries`, `traitAggregationSingle`) so the join is defined once.
 */
export function buildTraitsByTaxonMap(allTraits: readonly Trait[], traitGroup: string): Map<string, string[]> {
  const byTaxon = new Map<string, string[]>()
  for (const t of allTraits) {
    if (t.traitgroup !== traitGroup) continue
    const key = normTaxon(t.consensustaxon)
    if (!key) continue
    const list = byTaxon.get(key) ?? []
    list.push(t.traitname)
    byTaxon.set(key, list)
  }
  return byTaxon
}
